import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { INettingPrelevement } from 'src/app/shared/models/netting-prelevement';
import { UtilsService } from 'src/app/shared/services/utils.service';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class NettingPrelevementService {
    options = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*' })
    };


    constructor(private http: HttpClient,
        private utilsService: UtilsService) {
    }

    getNettingsPrelevements(): Observable<INettingPrelevement[]> {
        return this.http.get<INettingPrelevement[]>(environment.backendApiUrl + "/nettings-prelevement-name", this.options).pipe(catchError(this.utilsService.handleError));
    }

    createNettingsPrelevement(n: INettingPrelevement): Observable<INettingPrelevement> {
        return this.http.post<INettingPrelevement>(environment.backendApiUrl + "/nettings-prelevement-name", n, this.options).pipe(catchError(this.utilsService.handleError));
    }

    updateNettingsPrelevement(n: INettingPrelevement): Observable<INettingPrelevement> {
        return this.http.put<INettingPrelevement>(environment.backendApiUrl + "/nettings-prelevement-name/" + n.id, n, this.options).pipe(catchError(this.utilsService.handleError));
    }

    deleteNettingsPrelevement(n: INettingPrelevement): Observable<any> {
        return this.http.delete<INettingPrelevement>(environment.backendApiUrl + "/nettings-prelevement-name/" + n.id, this.options).pipe(catchError(this.utilsService.handleError));
    }

    exportData(): Observable<any> {
        return this.http.get(environment.backendApiUrl + "/nettings-prelevement-name/export", { responseType: 'blob' }).pipe(catchError(this.utilsService.handleError));
    }

}
